// ---------------------------------------------------------------------------
// Teacher Assignment – Feature metadata (follows project convention)
// ---------------------------------------------------------------------------
import { UserGroupIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";

export const TeacherAssignmentFeature: FeatureMetadata = {
  id: "teacherAssignment",
  moduleName: "academics",

  navigation: {
    label: "Teacher Assignments",
    path: "/teacher-assignments",
    icon: UserGroupIcon,
    order: 6,
  },

  route: {
    path: "/teacher-assignments",
    element: lazy(() => import("./pages/TeacherAssignmentPage")),
  },

  permissions: {
    view: "Academics.TeacherAssignment.view",
    create: "Academics.TeacherAssignment.create",
    edit: "Academics.TeacherAssignment.edit",
    delete: "Academics.TeacherAssignment.delete",
  },

  readiness: "live",
};
